import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cross_sale container"
}
const _hoisted_2 = { class: "cross_sale__banner w-100" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "cross_sale__content my-2" }
const _hoisted_5 = { class: "cross_sale__products" }
const _hoisted_6 = { class: "desc-crosssell" }
const _hoisted_7 = {
  key: 0,
  class: "plus"
}
const _hoisted_8 = { class: "result" }
const _hoisted_9 = { class: "discount_price" }
const _hoisted_10 = { class: "original_price" }
const _hoisted_11 = { class: "cross_sale__actions mb-4" }

import { ref } from "vue";
import { ElNotification } from "element-plus";
import crossSaleService from "@/services/crossSale";
import handleError from "@/helper/handleError";
import { useRouter } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'crossSale',
  props: {
  sale: Object,
  orderID: String,
  productID: String,
},
  setup(__props) {

const router = useRouter();
// ====================== initialize data ========================

const canceled = ref(false);
const props = __props;

const isReqLoading = ref(false);

// ========================== Methods ===================

// add cross sale to order
const addToOrder = () => {
  isReqLoading.value = true;
  const updatedCartData = {
    cross_sell_ids: props.sale?.id ? [props.sale.id] : [],
  };
  // here is if the payment method is online
  crossSaleService.updateOrderValue(props.orderID, updatedCartData, props.productID)
  .then((res: any) => {
      // On Thank You page, fire UPSELL PURCHASE custom event for the additional cross-sell
      let pixel_tracking = res.data.data.pixel_tracking;

      const script = document.createElement('script');
      let html = ``;
      const pixelTrackingData = {
        ...pixel_tracking,
        page_url: window.location.href
      };

      // Fire UPSELL PURCHASE custom event (not Purchase, since Purchase already fired for main product)
      html += `
        // For Facebook Pixel - Custom Event for Upsell Purchase
        if (typeof fbq !== "undefined") {
          fbq('trackCustom', 'UPSELL PURCHASE', ${JSON.stringify(pixelTrackingData)});
        }
      `;

      // Prepare TikTok pixel data with content_type adjustment
      const tiktokPixelData = { ...pixelTrackingData };
      if (tiktokPixelData.content_type && tiktokPixelData.content_type !== 'product') {
        tiktokPixelData.content_type = 'product_group';
      }

      html += `
        if (typeof ttq !== "undefined") {
          ttq.track('UPSELL PURCHASE', ${JSON.stringify(tiktokPixelData)});
        }
      `;
      script.innerHTML = html;
      document.head.appendChild(script);
    })
    .then(() => {
      ElNotification({
        title: "Success",
        message: "added to order",
        type: "success",
      });

      // Clear pixel tracking flag since order value has changed
      // This allows Purchase event to fire again on thank you page with updated total
      const trackingKey = `pixel_tracked_${props.orderID}`;
      localStorage.removeItem(trackingKey);

      canceled.value = true;
      if (router.currentRoute.value.path === '/pages/confirmation') {
        const currentQuery = {
          ...router.currentRoute.value.query,
          crossSaleAdded: 'true'
        };

        router.push({
          path: '/pages/thank',
          query: currentQuery
        });
      }

    }).catch((err: any) => {
      handleError(err);
    });
};

// Define the cancelOrder method
const cancelOrder = () => {
  canceled.value = true;

  if (router.currentRoute.value.path === '/pages/confirmation') {

    const currentQuery = {
      ...router.currentRoute.value.query,
    };

    router.push({
      path: '/pages/thank',
      query: currentQuery
    });

  }
};

return (_ctx: any,_cache: any) => {
  return (!canceled.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: __props.sale?.image,
            alt: "Cross Sale",
            class: "img-fluid"
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(__props.sale?.name), 1),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sale?.products, (product, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createTextVNode(_toDisplayString(product.label) + " ", 1),
                  (index < __props.sale?.products.length - 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "+"))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(__props.sale?.sell_price), 1),
              _createElementVNode("p", _hoisted_10, _toDisplayString(__props.sale?.original_price), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: _normalizeClass(["buy_button btn btn--primary", isReqLoading.value ? 'loading disabled' : '']),
            onClick: addToOrder,
            "aria-label": "Buy"
          }, " اضف للطلب ", 2),
          _createElementVNode("button", {
            class: "cancel_button btn btn--primary",
            onClick: cancelOrder,
            "aria-label": "Cancel"
          }, " لا اريد العرض ")
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})